import MessageComposeAdapter from '../../adapters/MessageComposeAdapter';
import { ApiMethodCallback } from '../ApiMethod';
import { getAdapter } from '../../adapters/AdapterManager';
import { createSuccessResult, createErrorResult } from '../ApiMethodResponseCreator';
import { AttachmentDetails } from './AttachmentDetails';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import AppointmentComposeAdapter from '../../adapters/AppointmentComposeAdapter';
import { ApiErrorCode } from '../ApiErrorCode';
import { isFeatureEnabled } from 'owa-feature-flags';
import { SsoErrorCode } from 'owa-addins-sso';

export default async function getAttachmentsAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: null,
    callback: ApiMethodCallback
) {
    if (!isFeatureEnabled('addin-attachmentApis')) {
        callback(createErrorResult(SsoErrorCode.OperationNotSupported));
        return;
    }

    const adapter = getAdapter(hostItemIndex);
    let content: AttachmentDetails[] = null;
    let attachments: AttachmentDetails[] = [];

    switch (adapter.mode) {
        case ExtensibilityModeEnum.MessageCompose:
            content = await (adapter as MessageComposeAdapter).getAttachments();
            break;

        case ExtensibilityModeEnum.AppointmentOrganizer:
            content = await (adapter as AppointmentComposeAdapter).getAttachments();
            break;
    }

    if (content == null) {
        callback(createErrorResult(ApiErrorCode.GenericResponseError));
        return;
    }
    attachments = content.map(
        wrapper =>
            <AttachmentDetails>{
                id: wrapper.id,
                name: wrapper.name,
                contentType: wrapper.contentType,
                size: wrapper.size,
                attachmentType: wrapper.attachmentType,
                isInline: wrapper.isInline,
            }
    );

    try {
        callback(createSuccessResult(attachments));
    } catch (err) {
        callback(createErrorResult(err.errorCode));
    }
}
